module.exports = __webpack_public_path__ + "img/invalid-payment-link.4c4c9a84.svg";